import { getToken } from "./Sessions.jsx";

const setAxiosHeader = (config) => {
    const token = getToken();
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
};

export default setAxiosHeader;
